var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69724 15.3945C9.40504 15.3941 11.0636 14.8224 12.4089 13.7704L16.6385 18L17.999 16.6395L13.7694 12.4099C14.822 11.0645 15.3941 9.40549 15.3945 7.69724C15.3945 3.45318 11.9413 0 7.69724 0C3.45318 0 0 3.45318 0 7.69724C0 11.9413 3.45318 15.3945 7.69724 15.3945ZM7.69724 1.92431C10.881 1.92431 13.4702 4.51347 13.4702 7.69724C13.4702 10.881 10.881 13.4702 7.69724 13.4702C4.51347 13.4702 1.92431 10.881 1.92431 7.69724C1.92431 4.51347 4.51347 1.92431 7.69724 1.92431Z",
    fill: "#C4CACD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.163947c81149ef4d704be3bc8446693b.svg";
export { ForwardRef as ReactComponent };